import { useState } from 'react';
import { useGenericModal } from '..';
import {
  ConnectAiProviderModal,
  ConnectAiProviderModalProps,
} from './connect-ai-provider-modal';

export const useConnectAiProviderModal = (
  props?: Partial<ConnectAiProviderModalProps>
) => {
  const { modalRef, openModal, closeModal } = useGenericModal();
  const [modalType, setModalType] =
    useState<ConnectAiProviderModalProps['type']>();

  const [providerId, setProviderId] =
    useState<ConnectAiProviderModalProps['provider']>();

  const modalComponent = (
    <ConnectAiProviderModal
      testId={props?.testId}
      modalRef={modalRef}
      onClose={closeModal}
      provider={providerId}
      type={modalType}
    />
  );

  const openAiProviderModal = (
    provider: ConnectAiProviderModalProps['provider'],
    type?: ConnectAiProviderModalProps['type']
  ) => {
    setProviderId(provider);
    setModalType(type);
    openModal();
  };

  return {
    modalRef,
    openModal: openAiProviderModal,
    closeModal,
    connectAiProviderModal: modalComponent,
  };
};
